const {
  i18n: { __ },
  components: { TextControl },
} = wp;

const ContactFormSettings = (props) => {
  const { attributes, setAttributes } = props;
  const { contactForm } = attributes;

  return (
    <TextControl
      label={__('Contact Form ID', 'b3rg')}
      value={contactForm.contactFormId}
      onChange={(newValue) => {
        setAttributes({
          contactForm: {
            ...contactForm,
            contactFormId: newValue,
          },
        });
      }}
    />
  );
};

export default ContactFormSettings;
